import { AddCarForm } from '@/components/dashboard/AddCarForm';

export default function HostAddCar() {
  return <AddCarForm />;
}
